<template>
  <div
    class="iconTitle-setting"
    :style="{
      background: data.backgroundColor,
      'margin-bottom': (data.marginBottom ) / 16 + 'rem',
      lineHeight: (data.lineHeight ) / 16 + 'rem',
    }"
  >
    <img
      class="iconTitle-setting-img"
      :style="{
        width: (data.imgWidth ) / 16 + 'rem',
        height: (data.imgHeight ) / 16 + 'rem',
        'margin-left': (data.imgMarginLeft ) / 16 + 'rem',
        'margin-right': (data.imgMarginRight ) / 16 + 'rem',
      }"
      :src="data.imgUrl"
    >
    <div>
      <div
        :style="{
          fontSize: (data.fontSize ) / 16 + 'rem',
          fontWeight: data.fontWeight,
          color: data.titleColor,
          fontFamily: data.family,
        }"
      >{{ data.title }}</div>
      <div v-if="data.showSubTitle" :style="{
        fontSize: (data.subFontSize ) / 16 + 'rem',
        fontWeight: data.subFontWeight,
        color: data.subColor,
        fontFamily: data.subFamily,
        'margin-top': (data.subMarginTop ) / 16 + 'rem'
      }">{{ data.subTitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IconTitle",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>

<style lang="less" scoped>
.iconTitle-setting {
  overflow: hidden;
  border-radius: 5px;
  padding: 0 10px;
  word-break: break-all;
  white-space: pre-line;
  display: flex;
  align-items: center;
}
</style>
